import React from 'react';
import './Loader.css';

// Summery loading state: a sun rising over shimmering water.
function Loader({ text }) {
  return (
    <div className="loader">
      <div className="loader-scene">
        <div className="loader-sun" />
        <div className="loader-wave loader-wave-1" />
        <div className="loader-wave loader-wave-2" />
        <div className="loader-wave loader-wave-3" />
      </div>
      {text && <div className="loader-text">{text}</div>}
    </div>
  );
}

export default Loader;
